import styled from 'styled-components';
import { subjectTypes } from '../../@types/entities/subjects.entity';
import getSubjectsType from '../../utils/get-Subject-Types';

interface propTypes {
  $subject: subjectTypes | string;
  $color: 10 | 20 | 30 | 40 | 50;
}

export const WrapButton = styled.div`
  display: block;
  margin: 1em 0;
  text-align: center;
  ${({ theme }) => theme.spacing.articleBody}
`;

export const Button = styled.a<propTypes>`
  width: 100%;
  border-radius: 8px;
  border: 1px solid ${({ theme, $subject }) => getSubjectsType({ color: 20, subject: $subject, theme })};
  border-left: 8px solid ${({ theme, $subject }) => getSubjectsType({ color: 20, subject: $subject, theme })};
  padding: 13px 20px 13px 28px;
  min-height: 76px;
  transition: .3s ease;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  margin: auto;
  gap: 5px;

  &:hover{
    background: ${({ theme, $subject }) => getSubjectsType({ color: 40, subject: $subject, theme })};
  }

  text-decoration: none !important;
  font-family: 'Museo';
  color: #000 !important;
  font-weight: 600 !important;

  @media (max-width: 600px){
    padding: 5px;
  }
`;
